// Category action types
export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const FETCH_POPULAR_CATEGORIES_REQUEST = 'FETCH_POPULAR_CATEGORIES_REQUEST';
export const FETCH_POPULAR_CATEGORIES_SUCCESS = 'FETCH_POPULAR_CATEGORIES_SUCCESS';
export const FETCH_POPULAR_CATEGORIES_FAILURE = 'FETCH_POPULAR_CATEGORIES_FAILURE';

export const FETCH_CATEGORY_BY_SLUG_REQUEST = 'FETCH_CATEGORY_BY_SLUG_REQUEST';
export const FETCH_CATEGORY_BY_SLUG_SUCCESS = 'FETCH_CATEGORY_BY_SLUG_SUCCESS';
export const FETCH_CATEGORY_BY_SLUG_FAILURE = 'FETCH_CATEGORY_BY_SLUG_FAILURE';

export const FETCH_CATEGORY_ARTICLES_REQUEST = 'FETCH_CATEGORY_ARTICLES_REQUEST';
export const FETCH_CATEGORY_ARTICLES_SUCCESS = 'FETCH_CATEGORY_ARTICLES_SUCCESS';
export const FETCH_CATEGORY_ARTICLES_FAILURE = 'FETCH_CATEGORY_ARTICLES_FAILURE';

export const CREATE_CATEGORY_REQUEST = 'CREATE_CATEGORY_REQUEST';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';

export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE';

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';


